import React from 'react';
import { connect } from 'react-redux';
import './loading.css';

const Loading = () => {
  const balls = [];
  for (let i = 0; i < 7; i++) {
    balls.push(<div className="ball-dark" />);
  }

  return (
    <div className="loading-container-dark" style={{ paddingTop: '20rem' }}>
      {balls}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    darkmode: state.darkmode,
  };
};

export default connect(mapStateToProps, null)(Loading);
